import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styled from 'styled-components';

const webglEnabled = process.env.REACT_APP_MODE === 'webgl';

const StyledContainer = styled.div`
  position: relative;
  width: 100%;
  //min-height: 100vh;
  box-sizing: border-box;
  padding: ${!webglEnabled ? 4.5 : 0}rem
    ${props => (props.breakpoint === 'phone' ? 2.5 : 1.875)}rem 0;
`;

const PageContainer = props => {
  const { breakpoint, children, className, typography } = props;
  const containerClass = classnames(className, {
    arial: typography === 'arial',
  });
  return (
    <StyledContainer
      id="content-wrap"
      className={containerClass}
      breakpoint={breakpoint}
    >
      {children}
    </StyledContainer>
  );
};

PageContainer.propTypes = {
  typography: PropTypes.string,
  breakpoint: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.element]),
  className: PropTypes.string,
};

PageContainer.defaultProps = {
  typography: 'default',
};

const mapStateToProps = state => {
  const { breakpoint } = state.layout;
  return {
    breakpoint,
  };
};

export default connect(mapStateToProps, null)(PageContainer);



// WEBPACK FOOTER //
// ./src/modules/content/components/PageContainer.js